const HSNType = {
  GET_HSN_LIST: "GET_HSN_LIST",
};
export default HSNType;
